export default __webpack_public_path__ + "static/media/seven.d5cabb8e.svg";